<!--
    导入电话簿
    jay 2020-01-02
 -->
<template>
  <Modal
    :value="importTelPop"
    :title="$t('recharge.selectLabel')"
    class-name="vertical-center-modal"
    width="490"
    :mask-closable="false"
    @on-cancel="closePop"
  >
    <div class="modal-container">
      <h3>
        <span>{{ $t("recharge.importNumber") }}</span>
      </h3>
      <div class="tag-wrapper">
        <span
          :class="{ active: checkTagIndex == index }"
          v-for="(tag, index) in tagList"
          :key="index"
          @click="checkTagEvent(index, true)"
        >
          {{ tag.tag_name }}
        </span>
      </div>
    </div>
    <div slot="footer" class="footer" align="center">
      <Button type="primary" :loading="importTelLoading" @click="importTelFun">
        {{ $t("recharge.immediatelyImport") }}
      </Button>
    </div>
  </Modal>
</template>

<script>
export default {
  props: {
    importTelPop: {
      type: Boolean,
      default: false
    },
    tagList: {
      //标签列表
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      importTelLoading: false,
      checkTagIndex: 0 //选中的标签
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    closePop() {
      this.$emit("update:importTelPop", false);
    },
    checkTagEvent(index) {
      //选择标签
      this.checkTagIndex = index;
    },
    importTelFun() {
      //导入电话簿
      let vm = this;
      vm.importTelLoading = true;
      let params = {};
      params.tag = vm.tagList[vm.checkTagIndex].id;
      vm.$post("/app/user/userMobiles", params, { alert: true }).then(res => {
        console.log(res);
        vm.importTelLoading = false;
        if (res.code == 0) {
          // vm.importTelPop = false;
          if (res.data.list.length) {
            let arr = [];
            for (let i = 0; i < res.data.list.length; i++) {
              arr.push(res.data.list[i].mobile);
            }
            vm.$emit("getTelData", arr);
            // vm.telArr = arr;
            // vm.updateMobile();
          } else {
            vm.$Message.error(vm.$t("recharge.labelNoNumber"));
          }
        }
      });
    }
  },
  components: {},
  watch: {},
  beforeDestroy() {}
};
</script>
<style lang="less" scoped>
@imgUrl: "~@/assets/images/";
.modal-container {
  p {
    font-size: 14px;
    color: #4a4a4a;
    line-height: 28px;
    margin-bottom: 20px;
  }
}

.footer {
  position: relative;
  .file {
    position: absolute;
    width: 330px;
    height: 45px;
    font-size: 20px;
    opacity: 0;
  }
  .tips {
    width: 330px;
    text-align: center;
    font-size: 12px;
    color: #666;
    padding-top: 10px;
  }
  .skip {
    display: block;
    margin-top: 24px;
    color: #2042ab;
    font-size: 16px;
    line-height: 22px;
    text-decoration: underline;
  }
  /deep/.ivu-btn-primary.text-gray {
    background: #b6b6b6;
    color: #ddd;
  }
  /deep/.ivu-btn-primary.text-gray:focus {
    box-shadow: 0 0 0 2px #ddd;
  }
}
.tag-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 0;
  /deep/.ivu-icon-ios-add-circle-outline {
    margin-right: 8px;
    color: #2042ab;
    cursor: pointer;
  }
  span {
    font-size: 14px;
    color: #4a4a4a;
    display: inline-block;
    padding: 0 15px;
    line-height: 28px;
    background: rgba(239, 242, 245, 1);
    border-radius: 14px;
    margin-right: 8px;
    cursor: pointer;
    &.active {
      background: #2042ab;
      color: #fff;
    }
  }
}
</style>
